import { useCallback } from "react";
import { useMutation } from "react-query";
import Network from "../../network";
import useUser from "../../user/hooks/use-user";

export default function useSend403() {

    const {libraryCode} = useUser();

    const {mutate, isLoading, isSuccess} = useMutation((data: {answers: string[], libCode: string}) => {
        return Network.sendTask403(data);
    })

    const send = useCallback((answers: string[]) => {
        if (libraryCode) {
            mutate({
                answers,
                libCode: libraryCode
            })
        }
    }, [libraryCode, mutate]);

    return {
        send,
        isLoading,
        isSuccess
    }
}
